export const EMPRESA = {
  NOMBRE: "MODEPRAN",
  CIF: "C.I.F. G98265705",
  DIRECCION1: "Camino Nuevo de Paterna 165",
  DIRECCION2: "Benimamet (Valencia)"
};

export const BASE = "0000000000";
export const BASE_COVERED = "**********";
